/* eslint-disable max-len */

export const CORN_NITROGEN_LIMITS_CONFIG = { min: 0, max: 270, step: 1 };
